var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "management-filters-wrapper" }, [
      _c(
        "div",
        { staticClass: "management-filters-flex-container" },
        [
          _c("SearchLabels", {
            attrs: {
              triggerSearchLabel: _vm.triggerSearchLabel,
              setTextValue: _vm.setTextValue,
              placeholder: `${_vm.$t("managementLabels.placeholder")}`
            }
          }),
          _c("div", { staticClass: "management-actions-container" }, [
            _c(
              "button",
              {
                staticClass: "management-filters-export-btn attribute-export",
                on: {
                  click: function($event) {
                    return _vm.openMenu("", "create")
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/drc/assets/icons/plus.svg"),
                    alt: _vm.$t("managementPage.export")
                  }
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("crudSideMenu.new")))])
              ]
            ),
            _c("div", { staticClass: "filter-buttons" }, [
              _c(
                "div",
                {
                  staticClass: "filter-button filter-button-approved",
                  class: _vm.statusFilters.APPROVED.active ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.toggleFilter("APPROVED")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("managementLabels.approved")))]
              ),
              _c(
                "div",
                {
                  staticClass: "filter-button filter-button-pending",
                  class: _vm.statusFilters.FOR_APPROVAL.active
                    ? "selected"
                    : "",
                  on: {
                    click: function($event) {
                      return _vm.toggleFilter("FOR_APPROVAL")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("managementLabels.forApproval")))]
              ),
              _c(
                "div",
                {
                  staticClass: "filter-button filter-button-inactive",
                  class: _vm.statusFilters.INACTIVE.active ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.toggleFilter("INACTIVE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("managementLabels.inactive")))]
              )
            ])
          ])
        ],
        1
      )
    ]),
    _c("div", { staticClass: "management-static-table-container" }, [
      _c(
        "table",
        [
          _c(
            "tr",
            _vm._l(_vm.headers, function(header, index) {
              return _c(
                "th",
                {
                  key: index,
                  class:
                    header.key !== "projectId" && header.key !== "action"
                      ? ""
                      : "unclickable",
                  on: {
                    click: function($event) {
                      return _vm.sortBy(header)
                    }
                  }
                },
                [
                  _vm._v(" " + _vm._s(header.label) + " "),
                  header.key === _vm.orderFieldName.key
                    ? _c("img", {
                        class: _vm.isSortHeader(header),
                        attrs: {
                          src: require("@/drc/assets/icons/arrow-down-white.svg"),
                          alt: "sort"
                        }
                      })
                    : _vm._e()
                ]
              )
            }),
            0
          ),
          _vm._l(_vm.rows, function(row, index) {
            return _c("tr", { key: row.id }, [
              _c("td", [_vm._v(_vm._s(row.name))]),
              _c("td", { staticClass: "attribute-type" }, [
                _c(
                  "span",
                  { staticClass: "tag", class: row.type.toLowerCase() },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.type === "CERTIFICATION"
                            ? _vm.$t("crudSideMenu.certification")
                            : _vm.$t("crudSideMenu.tool")
                        ) +
                        " "
                    )
                  ]
                )
              ]),
              _c(
                "td",
                { staticClass: "attribute-project-id" },
                [
                  _vm._l(row.projects, function(project, index) {
                    return _c("span", { key: index }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            index !== row.projects.length - 1
                              ? `${project.id},`
                              : `${project.id}`
                          ) +
                          " "
                      )
                    ])
                  }),
                  !row.projects || row.projects.length === 0
                    ? _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("managementLabels.noProjects")) +
                            " "
                        )
                      ])
                    : _vm._e()
                ],
                2
              ),
              _c("td", { staticClass: "attribute-created-date" }, [
                _vm._v(" " + _vm._s(_vm.convertDate(row.createdDate)) + " ")
              ]),
              _c("td", { staticClass: "attribute-creator" }, [
                _vm._v(_vm._s(row.createdBy))
              ]),
              _c("td", { staticClass: "attribute-actions" }, [
                _c("div", { staticClass: "button-container" }, [
                  _c(
                    "button",
                    {
                      staticClass: "table-action",
                      on: {
                        click: function($event) {
                          return _vm.openMenu(row, "edit")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("crudSideMenu.edit")))]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "table-action",
                      on: {
                        click: function($event) {
                          return _vm.deleteRow(row)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("crudSideMenu.delete")))]
                  )
                ])
              ]),
              _c("td", { staticClass: "attribute-status" }, [
                _c(
                  "span",
                  {
                    class: [
                      "single-status",
                      { "status-approved": row.approvalStatus === "APPROVED" },
                      { "status-inactive": row.approvalStatus === "INACTIVE" },
                      {
                        "status-for-approval":
                          row.approvalStatus === "FOR_APPROVAL"
                      }
                    ]
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.approvalStatus === "APPROVED"
                            ? _vm.$t("managementLabels.approved")
                            : row.approvalStatus === "FOR_APPROVAL"
                            ? _vm.$t("managementLabels.forApproval")
                            : _vm.$t("managementLabels.inactive")
                        ) +
                        " "
                    )
                  ]
                )
              ]),
              _c("td", { staticClass: "attribute-id" }, [
                _vm._v(_vm._s(row.id))
              ])
            ])
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }